import { render } from "./about-section.vue?vue&type=template&id=7a37045f"
import script from "./about-section.vue?vue&type=script&lang=js"
export * from "./about-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__